import { getCookie, setCookie, deleteCookie } from "@/helpers/cookies";

function redirect(href = window.location.origin) {
  window.location.href = href;
}

function post({ url, data, callback }) {
  const xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.onreadystatechange = function() {
    // Call a function when the state changes.
    if (xhr.readyState === XMLHttpRequest.DONE) {
      const status = xhr.status;
      if (status === 0 || (status >= 200 && status < 400)) {
        callback(JSON.parse(xhr.response));
      } else {
        // eslint-disable-next-line no-console
        console.error(xhr.status);
        redirect();
      }
    }
  };
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(JSON.stringify(data));
}

(function trackVisit() {
  try {
    post({
      url: `${process.env.VUE_APP_API_SERVER}api/affiliate_link/visit`,
      data: {
        visit_url: window.location.href,
        referrer_url: document.referrer,
        user_agent: navigator.userAgent,
        referral_cookie: getCookie("upm_aff") || undefined
      },
      callback: ({ data }) => {
        if (data.referral_cookie) {
          setCookie(
            "upm_aff",
            data.referral_cookie,
            data.referral_cookie_max_age
          );
        } else {
          deleteCookie("upm_aff");
        }

        try {
          const url = new URL(data.redirect_url);
          url.searchParams.set("upm_aff", "1");
          if (document.referrer)
            url.searchParams.set("upm_referrer", encodeURI(document.referrer));
          redirect(url.href);
        } catch {
          redirect(data.redirect_url);
        }
      }
    });
  } catch {
    redirect();
  }
})();
